<template>
  <!-- 更新弹框 -->
  <el-dialog
    :align-center="true"
    width="440px"
    :style="{
      'border-radius': '36px',
      'box-shadow': 'none',
      'background-color': 'transparent',
    }"
    modal-class="domain_name_update_dialog"
    v-model="dialogShow"
    center
    :z-index="9999"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="div_update_dialog" v-if="testUrl">
      <i class="iconfont i_close cp_us" @click="closeDialog">&#xe7d0;</i>
      <h3 class="h3_title">提示</h3>
      <div class="div_content">
        <p class="mb-20">
          当前您访问为测试版网址，如需体验完整内容<br />请前往正式版
        </p>
      </div>
      <div class="div_bottom">
        <el-button class="btn" @click="goToKeyMemo"
          >前往正式版</el-button
        >
      </div>
    </div>
    <div class="div_update_dialog" v-else>
      <h3 class="h3_title">域名更新提示</h3>
      <div class="div_content">
        <p class="mb-20">
          嗨，小伙伴们，Keymemo
          搬家了，新的访问地址为<a target="_self" :href="openUrl">https://www.conbrie.com/</a>。
        </p>
        <p>新开始，新征程。期待 蜂鸟轻记 陪伴大家一起学习，共同进步。</p>
      </div>
      <div class="div_bottom">
        <el-button class="btn" @click="toNewUrl"
          >访问新地址</el-button
        >
        <el-button class="btn" @click="addDesktop"
          >添加新的桌面快捷方式</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref } from "vue";
import { getLocalStor } from "@/utils/index";

let dialogShow = ref(false); //弹框显示状态
let testUrl = ref(false); // 是否是测试环境
let openUrl = ref('https://login.conbrie.com'); // 新网址

activities();

// 域名更新弹窗
function activities() {
  if(window.location.hostname === 'login.keymemox.com'){
    let userObj = getLocalStor("userMessage");
    let token = userObj?.token;
    if(token){
      openUrl.value = 'https://login.conbrie.com?token=' + encodeURIComponent(token);
    }
    dialogShow.value = true;
  }else if(window.location.hostname === 'login.keymemoapp.com' && localStorage.getItem("allowTestUrl") != "true"){
    dialogShow.value = true;
    testUrl.value = true;
    // 监听按键事件
    document.addEventListener("keydown", handleKeyDown);
  }
}
// 前往新网址
function toNewUrl() {
  window.location.replace(openUrl.value);
}

// 前往正式版
function goToKeyMemo() {
  window.location.replace("https://www.conbrie.com");
}
// 添加到桌面
function addDesktop() {
  let baseUrl = openUrl.value +
    "&addDesktop=true";
  window.location.replace(baseUrl);
}
// 监听按键事件
function handleKeyDown(event){
  // 监听用户点击shift+c
  if(event.shiftKey && event.code === "KeyC" && testUrl.value){
    closeDialog();
  }
}

// 关闭测试弹窗
function closeDialog(){
  // 允许打开测试环境页面
  localStorage.setItem("allowTestUrl", true)
  dialogShow.value = false;
  document.removeEventListener("keydown", handleKeyDown);
}
</script>

<style lang='scss'>
.domain_name_update_dialog{
  background-color: #f9f9f9 !important;
  .div_update_dialog {
    padding: 25px 30px;
    width: 100%;
    background-color: #ffffff;
    box-sizing: border-box;
    .i_close{
      width: 28px;
      line-height: 28px;
      text-align: center;
      position: fixed;
      top: 25px;
      right: 25px;
      color: transparent;
    }
    .h3_title {
      width: 100%;
      line-height: 28px;
      font-weight: 500;
      font-size: 20px;
      color: #282e3e;
      text-align: center;
    }
    .div_content {
      padding: 24px 0 46px;
      p {
        line-height: 22px;
        font-weight: 500;
        font-size: 16px;
        text-align: center;
        color: #282e3e;
      }
      .mb-20 {
        margin-bottom: 20px;
      }
      a{
        color: rgb(17, 124, 238);
      }
    }
    .div_bottom {
      .btn {
        width: 100%;
        height: 44px;
        background: #000000;
        border-radius: 8px 8px 8px 8px;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        &:nth-of-type(2) {
          margin: 20px 0 0;
          background-color: rgb(244, 244, 244);
          color: #000000;
        }
      }
    }
  }
}
</style>